import React from 'react';

interface CompassLogoProps {
  width?: number;
  height?: number;
  className?: string;
}

const CompassLogo: React.FC<CompassLogoProps> = ({
  width = 104,
  height = 29,
  className = ''
}) => {
  return (
    <div 
      className={`compass-logo ${className}`}
      style={{ 
        width: `${width}px`, 
        height: `${height}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {/* Compass Healthcare 247 Logo SVG - Exact match from Figma design */}
      <svg 
        width={width} 
        height={height} 
        viewBox="0 0 104 29" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Main green rectangle with medical cross */}
        <rect x="0" y="0" width="28.32" height="29" fill="#28A049"/>
        
        {/* Blue text elements - bottom row (CARE360 etc.) */}
        <g transform="translate(33.04, 17.85)">
          <rect x="0" y="0.6" width="5.56" height="5.84" fill="#0E7CC1"/>
          <rect x="5.96" y="0.45" width="3.81" height="5.97" fill="#0E7CC1"/>
          <rect x="12.25" y="0.6" width="5.86" height="5.69" fill="#0E7CC1"/>
          <rect x="18.55" y="2.06" width="3.68" height="4.35" fill="#0E7CC1"/>
          <rect x="22.82" y="2.06" width="4.02" height="4.35" fill="#0E7CC1"/>
          <rect x="27.05" y="0" width="2.2" height="6.29" fill="#0E7CC1"/>
          <rect x="29.54" y="1" width="2.79" height="5.41" fill="#0E7CC1"/>
          <rect x="32.5" y="0" width="4.69" height="6.29" fill="#0E7CC1"/>
          <rect x="37.71" y="2.06" width="3.61" height="4.35" fill="#0E7CC1"/>
          <rect x="41.88" y="2.06" width="4.02" height="4.35" fill="#0E7CC1"/>
          <rect x="46.12" y="2.06" width="3.45" height="4.23" fill="#0E7CC1"/>
          <rect x="49.8" y="2.06" width="3.68" height="4.35" fill="#0E7CC1"/>
          <rect x="56.06" y="0.69" width="3.63" height="5.6" fill="#0E7CC1"/>
          <rect x="60.22" y="0.77" width="3.99" height="5.52" fill="#0E7CC1"/>
          <rect x="64.56" y="0.04" width="1.98" height="7.77" fill="#0E7CC1"/>
          <rect x="67.2" y="0.81" width="3.6" height="5.47" fill="#0E7CC1"/>
        </g>
        
        {/* Green text elements - top row (COMPASS) */}
        <g transform="translate(32.88, 4.65)">
          <rect x="0" y="0" width="9.23" height="10.02" fill="#28A049"/>
          <rect x="9.83" y="0.01" width="10.46" height="10.03" fill="#28A049"/>
          <rect x="21.8" y="0.2" width="10.95" height="9.64" fill="#28A049"/>
          <rect x="34.74" y="0.2" width="8.49" height="9.64" fill="#28A049"/>
          <rect x="43.02" y="0.2" width="10.95" height="9.64" fill="#28A049"/>
          <rect x="54.17" y="0" width="8.14" height="10.03" fill="#28A049"/>
          <rect x="62.98" y="0" width="8.14" height="10.03" fill="#28A049"/>
        </g>
        
        {/* Orange accent rectangle */}
        <rect x="11.05" y="11.3" width="6.25" height="6.4" fill="#F37D41"/>
      </svg>
    </div>
  );
};

export default CompassLogo;
